export default __webpack_public_path__ + "static/media/human-rights.14ba5dfa.png";